import {SxProps} from "@mui/material";
import {getTheme} from "app/components/ThemeProvider/theme";

const theme = getTheme('light');

export const instantBox: SxProps = {
    display: 'flex',
    padding: '72px 0',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    gap: '20px'
}

export const instantMainText: SxProps = {
    fontSize: '24px',
    fontWeight: 600
}

export const instantText: SxProps = {
    fontSize: '18px',
    maxWidth: '743px'
}

export const registrBox: SxProps = {
    p: '40px',
    backgroundColor: 'white',
    minWidth: '335px',
    [theme.breakpoints.down('sm')]: {
        p: '24px 20px 32px 20px' ,
    },
}